import { createActions } from 'redux-actions'

export const INIT_ORDER_INFO = "INIT_ORDER_INFO";

export const CHECKOUT_START = "CHECKOUT_START";
export const CHECKOUT_SUCCESS = "CHECKOUT_SUCCESS";
export const CHECKOUT_FAIL = "CHECKOUT_FAIL";

export const REQUEST_PAYMENT_TYPE_START = "REQUEST_PAYMENT_TYPE_START";
export const REQUEST_PAYMENT_TYPE_SUCCESS = "REQUEST_PAYMENT_TYPE_SUCCESS";
export const REQUEST_PAYMENT_TYPE_FAIL = "REQUEST_PAYMENT_TYPE_FAIL";

export const GET_CART_LIST_START = "GET_CART_LIST_START";
export const GET_CART_LIST_SUCCESS = "GET_CART_LIST_SUCCESS";
export const GET_CART_LIST_FAIL = "GET_CART_LIST_FAIL";

export const EDIT_CART_START = "EDIT_CART_START";
export const EDIT_CART_SUCCESS = "EDIT_CART_SUCCESS";
export const EDIT_CART_FAIL = "EDIT_CART_FAIL";

export const CREATE_ORDER_START = "CREATE_ORDER_START";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";

export const REQUEST_ORDER_START = "REQUEST_ORDER_START";
export const REQUEST_ORDER_SUCCESS = "REQUEST_ORDER_SUCCESS";
export const REQUEST_ORDER_FAIL = "REQUEST_ORDER_FAIL";

export const REQUEST_ORDER_STATE_START = "REQUEST_ORDER_STATE_START";
export const REQUEST_ORDER_STATE_SUCCESS = "REQUEST_ORDER_STATE_SUCCESS";
export const REQUEST_ORDER_STATE_FAIL = "REQUEST_ORDER_STATE_FAIL";

export const REQUEST_DELIVERY_TYPE_START = "REQUEST_DELIVERY_TYPE_START";
export const REQUEST_DELIVERY_TYPE_SUCCESS = "REQUEST_DELIVERY_TYPE_SUCCESS";
export const REQUEST_DELIVERY_TYPE_FAIL = "REQUEST_DELIVERY_TYPE_FAIL";

export const REQUEST_ORDER_HISTORY_LIST_START = "REQUEST_ORDER_HISTORY_LIST_START";
export const REQUEST_ORDER_HISTORY_LIST_SUCCESS = "REQUEST_ORDER_HISTORY_LIST_SUCCESS";
export const REQUEST_ORDER_HISTORY_LIST_FAIL = "REQUEST_ORDER_HISTORY_LIST_FAIL";

export const ORDER_HISTORY_SET_STATE_START = "ORDER_HISTORY_SET_STATE_START";
export const ORDER_HISTORY_SET_STATE_SUCCESS = "ORDER_HISTORY_SET_STATE_SUCCESS";
export const ORDER_HISTORY_SET_STATE_FAIL = "ORDER_HISTORY_SET_STATE_FAIL";

export const REQUEST_ORDER_HISTORY_DETAIL_START = "REQUEST_ORDER_HISTORY_DETAIL_START";
export const REQUEST_ORDER_HISTORY_DETAIL_SUCCESS = "REQUEST_ORDER_HISTORY_DETAIL_SUCCESS";
export const REQUEST_ORDER_HISTORY_DETAIL_FAIL = "REQUEST_ORDER_HISTORY_DETAIL_FAIL";

export const REQUEST_GEO_START = "REQUEST_GEO_START";
export const REQUEST_GEO_SUCCESS = "REQUEST_GEO_SUCCESS";
export const REQUEST_GEO_FAIL = "REQUEST_GEO_FAIL";

export const ORDER_HISTORY_CALCULATE_START = "ORDER_HISTORY_CALCULATE_START";
export const ORDER_HISTORY_CALCULATE_SUCCESS = "ORDER_HISTORY_CALCULATE_SUCCESS";
export const ORDER_HISTORY_CALCULATE_FAIL = "ORDER_HISTORY_CALCULATE_FAIL";

export const ORDER_HISTORY_EDIT_START = "ORDER_HISTORY_EDIT_START";
export const ORDER_HISTORY_EDIT_SUCCESS = "ORDER_HISTORY_EDIT_SUCCESS";
export const ORDER_HISTORY_EDIT_FAIL = "ORDER_HISTORY_EDIT_FAIL";

export const EXPORT_ORDER_HISTORY_START = "EXPORT_ORDER_HISTORY_START";
export const EXPORT_ORDER_HISTORY_SUCCESS = "EXPORT_ORDER_HISTORY_SUCCESS";
export const EXPORT_ORDER_HISTORY_FAIL = "EXPORT_ORDER_HISTORY_FAIL";

export const REQUEST_ORDER_CALCULATE_LIST_START = "REQUEST_ORDER_CALCULATE_LIST_START";
export const REQUEST_ORDER_CALCULATE_LIST_SUCCESS = "REQUEST_ORDER_CALCULATE_LIST_SUCCESS";
export const REQUEST_ORDER_CALCULATE_LIST_FAIL = "REQUEST_ORDER_CALCULATE_LIST_FAIL";

export const {

    initOrderInfo,

    checkoutStart,
    checkoutSuccess,
    checkoutFail,

    requestPaymentTypeStart,
    requestPaymentTypeSuccess,
    requestPaymentTypeFail,

    getCartListStart,
    getCartListSuccess,
    getCartListFail,

    editCartStart,
    editCartSuccess,
    editCartFail,

    createOrderStart,
    createOrderSuccess,
    createOrderFail,

    requestOrderStart,
    requestOrderSuccess,
    requestOrderFail,

    requestOrderStateStart,
    requestOrderStateSuccess,
    requestOrderStateFail,

    requestDeliveryTypeStart,
    requestDeliveryTypeSuccess,
    requestDeliveryTypeFail,

    requestOrderHistoryListStart,
    requestOrderHistoryListSuccess,
    requestOrderHistoryListFail,

    orderHistorySetStateStart,
    orderHistorySetStateSuccess,
    orderHistorySetStateFail,

    requestOrderHistoryDetailStart,
    requestOrderHistoryDetailSuccess,
    requestOrderHistoryDetailFail,

    requestGeoStart,
    requestGeoSuccess,
    requestGeoFail,

    orderHistoryCalculateStart,
    orderHistoryCalculateSuccess,
    orderHistoryCalculateFail,

    orderHistoryEditStart,
    orderHistoryEditSuccess,
    orderHistoryEditFail,

    exportOrderHistoryStart,
    exportOrderHistorySuccess,
    exportOrderHistoryFail,

    requestOrderCalculateListStart,
    requestOrderCalculateListSuccess,
    requestOrderCalculateListFail,

} = createActions({

    [INIT_ORDER_INFO]: (req) => ({ req }),

    [CHECKOUT_START]: (req) => ({ ...req }),
    [CHECKOUT_SUCCESS]: (res) => ({ res }),
    [CHECKOUT_FAIL]: (res) => ({ res }),

    [REQUEST_PAYMENT_TYPE_START]: (req) => ({ ...req }),
    [REQUEST_PAYMENT_TYPE_SUCCESS]: (res) => ({ res }),
    [REQUEST_PAYMENT_TYPE_FAIL]: (res) => ({ res }),

    [GET_CART_LIST_START]: (req) => ({ ...req }),
    [GET_CART_LIST_SUCCESS]: (res) => ({ res }),
    [GET_CART_LIST_FAIL]: (res) => ({ res }),

    [EDIT_CART_START]: (req) => ({ ...req }),
    [EDIT_CART_SUCCESS]: (res) => ({ res }),
    [EDIT_CART_FAIL]: (res) => ({ res }),

    [CREATE_ORDER_START]: (req) => ({ ...req }),
    [CREATE_ORDER_SUCCESS]: (res) => ({ res }),
    [CREATE_ORDER_FAIL]: (res) => ({ res }),

    [REQUEST_ORDER_START]: (req) => ({ ...req }),
    [REQUEST_ORDER_SUCCESS]: (res) => ({ res }),
    [REQUEST_ORDER_FAIL]: (res) => ({ res }),

    [REQUEST_ORDER_STATE_START]: (req) => ({ ...req }),
    [REQUEST_ORDER_STATE_SUCCESS]: (res) => ({ res }),
    [REQUEST_ORDER_STATE_FAIL]: (res) => ({ res }),

    [REQUEST_DELIVERY_TYPE_START]: (req) => ({ ...req }),
    [REQUEST_DELIVERY_TYPE_SUCCESS]: (res) => ({ res }),
    [REQUEST_DELIVERY_TYPE_FAIL]: (res) => ({ res }),

    [REQUEST_ORDER_HISTORY_LIST_START]: (req) => ({ ...req }),
    [REQUEST_ORDER_HISTORY_LIST_SUCCESS]: (res) => ({ res }),
    [REQUEST_ORDER_HISTORY_LIST_FAIL]: (res) => ({ res }),


    [ORDER_HISTORY_SET_STATE_START]: (req) => ({ ...req }),
    [ORDER_HISTORY_SET_STATE_SUCCESS]: (res) => ({ res }),
    [ORDER_HISTORY_SET_STATE_FAIL]: (res) => ({ res }),

    [REQUEST_ORDER_HISTORY_DETAIL_START]: (req) => ({ ...req }),
    [REQUEST_ORDER_HISTORY_DETAIL_SUCCESS]: (res) => ({ res }),
    [REQUEST_ORDER_HISTORY_DETAIL_FAIL]: (res) => ({ res }),

    [REQUEST_GEO_START]: (req) => ({ ...req }),
    [REQUEST_GEO_SUCCESS]: (res) => ({ res }),
    [REQUEST_GEO_FAIL]: (res) => ({ res }),

    [ORDER_HISTORY_CALCULATE_START]: (req) => ({ ...req }),
    [ORDER_HISTORY_CALCULATE_SUCCESS]: (res) => ({ res }),
    [ORDER_HISTORY_CALCULATE_FAIL]: (res) => ({ res }),

    [ORDER_HISTORY_EDIT_START]: (req) => ({ ...req }),
    [ORDER_HISTORY_EDIT_SUCCESS]: (res) => ({ res }),
    [ORDER_HISTORY_EDIT_FAIL]: (res) => ({ res }),

    [EXPORT_ORDER_HISTORY_START]: (req) => ({ ...req }),
    [EXPORT_ORDER_HISTORY_SUCCESS]: (res) => ({ res }),
    [EXPORT_ORDER_HISTORY_FAIL]: (res) => ({ res }),


    [REQUEST_ORDER_CALCULATE_LIST_START]: (req) => ({ ...req }),
    [REQUEST_ORDER_CALCULATE_LIST_SUCCESS]: (res) => ({ res }),
    [REQUEST_ORDER_CALCULATE_LIST_FAIL]: (res) => ({ res }),

})


